/*
 * OrtoSen PDP — wspólny skrypt dla rozbitych sekcji (google-ads-ortosen-2-0).
 * Logika 1:1 z oryginalnego monolitu Custom Liquid. Dodane TYLKO:
 *  - opakowanie w init(scope) + markery `data-osb-*` => idempotencja (13 sekcji, brak podwójnych listenerów),
 *  - uruchomienie raz na DOMContentLoaded + re-init na `shopify:section:load` (dla edytora motywu).
 * Na żywym storefroncie zachowanie identyczne jak wcześniej (jeden przebieg po pełnym DOM).
 */
(function(){
  function init(scope){
    scope = scope || document;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;

    /* ---- reveal on scroll ---- */
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-reveal]:not([data-osb-rv])'));
    items.forEach(function(el){ el.setAttribute('data-osb-rv',''); });
    if (reduce || !hasIO) {
      items.forEach(function(el){ el.setAttribute('data-visible',''); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.setAttribute('data-visible',''); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      items.forEach(function(el){ io.observe(el); });
    }

    /* ---- tabs ---- */
    scope.querySelectorAll('[data-tabset]:not([data-osb-tab])').forEach(function(group){
      group.setAttribute('data-osb-tab','');
      group.querySelectorAll('[data-tab]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var key = btn.getAttribute('data-tab');
          group.querySelectorAll('[data-tab]').forEach(function(b){ b.removeAttribute('data-active'); });
          group.querySelectorAll('[data-panel]').forEach(function(p){ p.removeAttribute('data-active'); });
          btn.setAttribute('data-active','');
          var panel = group.querySelector('[data-panel="'+key+'"]');
          if (panel) panel.setAttribute('data-active','');
        });
      });
    });

    /* ---- count-up ---- */
    function fmt(n){ return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    function runCount(el){
      var target = parseInt(el.getAttribute('data-count'), 10) || 0;
      var suf = el.getAttribute('data-suffix') || '';
      if (reduce){ el.textContent = fmt(target) + suf; return; }
      var dur = 1300, start = null;
      function step(ts){
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = fmt(Math.floor(p * target)) + suf;
        if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target) + suf;
      }
      requestAnimationFrame(step);
    }
    var counters = Array.prototype.slice.call(scope.querySelectorAll('[data-count]:not([data-osb-cnt])'));
    counters.forEach(function(c){ c.setAttribute('data-osb-cnt',''); });
    if (reduce || !hasIO) {
      counters.forEach(runCount);
    } else {
      var io2 = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting){ runCount(e.target); io2.unobserve(e.target); } });
      }, { threshold: 0.6 });
      counters.forEach(function(c){ io2.observe(c); });
    }

    /* ---- buy buttons (scroll to top) ---- */
    scope.querySelectorAll('[data-buy]:not([data-osb-buy])').forEach(function(btn){
      btn.setAttribute('data-osb-buy','');
      btn.addEventListener('click', function(e){
        if (e && e.preventDefault) e.preventDefault();
        var beh = reduce ? 'auto' : 'smooth';
        try { window.scrollTo({ top: 0, left: 0, behavior: beh }); }
        catch (err) { window.scrollTo(0, 0); }
        var se = document.scrollingElement || document.documentElement;
        if (se && se.scrollTop > 0) { try { se.scrollTo({ top: 0, behavior: beh }); } catch (e2) { se.scrollTop = 0; } }
      });
    });

    /* ---- autoplay tabs ---- */
    scope.querySelectorAll('[data-autoplay]:not([data-osb-auto])').forEach(function(group){
      group.setAttribute('data-osb-auto','');
      var tabs = Array.prototype.slice.call(group.querySelectorAll('[data-tab]'));
      if (reduce || tabs.length < 2) return;
      var interval = parseInt(group.getAttribute('data-autoplay'), 10) || 3000;
      var timer = null, stopped = false;
      function activeIndex(){
        for (var i = 0; i < tabs.length; i++){ if (tabs[i].hasAttribute('data-active')) return i; }
        return 0;
      }
      function activate(i){
        var btn = tabs[i];
        if (!btn) return;
        var key = btn.getAttribute('data-tab');
        group.querySelectorAll('[data-tab]').forEach(function(b){ b.removeAttribute('data-active'); });
        group.querySelectorAll('[data-panel]').forEach(function(p){ p.removeAttribute('data-active'); });
        btn.setAttribute('data-active','');
        var panel = group.querySelector('[data-panel="'+key+'"]');
        if (panel) panel.setAttribute('data-active','');
      }
      function tick(){ if (!stopped) activate((activeIndex() + 1) % tabs.length); }
      function start(){ if (!stopped && !timer) timer = setInterval(tick, interval); }
      function stop(){ stopped = true; if (timer){ clearInterval(timer); timer = null; } }
      tabs.forEach(function(b){ b.addEventListener('click', stop); });
      if (!hasIO) { start(); }
      else {
        var io3 = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if (e.isIntersecting) start(); });
        }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
        io3.observe(group);
      }
    });

    /* ---- video carousel ---- */
    scope.querySelectorAll('[data-vidtrack]:not([data-osb-vid])').forEach(function(track){
      track.setAttribute('data-osb-vid','');
      var carousel = track.closest('[data-vidcarousel]') || track.parentElement;
      var dotsWrap = carousel.querySelector('[data-viddots]');
      var prevBtn = carousel.querySelector('[data-vidprev]');
      var nextBtn = carousel.querySelector('[data-vidnext]');
      var slides = Array.prototype.slice.call(track.children);
      var videos = slides.map(function(s){ return s.querySelector('video'); });
      function stepW(){ return (slides[0] ? slides[0].offsetWidth : track.clientWidth) + 18; }
      if (prevBtn) prevBtn.addEventListener('click', function(){ track.scrollBy({ left: -stepW(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function(){ track.scrollBy({ left: stepW(), behavior: 'smooth' }); });
      var dots = [];
      if (dotsWrap && slides.length > 1){
        slides.forEach(function(s, i){
          var d = document.createElement('button');
          d.type = 'button'; d.setAttribute('data-viddot',''); d.setAttribute('aria-label', 'Wideo ' + (i + 1));
          d.addEventListener('click', function(){ track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' }); });
          dotsWrap.appendChild(d);
        });
        dots = Array.prototype.slice.call(dotsWrap.children);
      }
      function setActive(i){
        dots.forEach(function(d, j){ if (j === i) d.setAttribute('data-active',''); else d.removeAttribute('data-active'); });
        if (prevBtn) prevBtn.disabled = (i <= 0);
        if (nextBtn) nextBtn.disabled = (i >= slides.length - 1);
      }
      setActive(0);
      var raf;
      track.addEventListener('scroll', function(){
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function(){
          var center = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
          slides.forEach(function(s, i){ var sc = s.offsetLeft + s.offsetWidth / 2, dist = Math.abs(sc - center); if (dist < bestD){ bestD = dist; best = i; } });
          setActive(best);
        });
      }, { passive: true });
      function setMuted(v, mute){
        v.muted = mute;
        var b = v.parentElement.querySelector('[data-vidsound]');
        if (b){ if (mute) b.setAttribute('data-muted',''); else b.removeAttribute('data-muted'); b.setAttribute('aria-label', mute ? 'Włącz dźwięk' : 'Wycisz'); }
      }
      function toggleSound(v){
        var unmute = v.muted;
        if (unmute){ videos.forEach(function(o){ if (o && o !== v) setMuted(o, true); }); }
        setMuted(v, !unmute);
        var pr = v.play(); if (pr && pr.catch) pr.catch(function(){});
      }
      videos.forEach(function(v){
        if (!v) return;
        setMuted(v, true);
        v.addEventListener('click', function(){ toggleSound(v); });
        var b = v.parentElement.querySelector('[data-vidsound]');
        if (b) b.addEventListener('click', function(e){ e.stopPropagation(); toggleSound(v); });
      });
      if (hasIO && !reduce){
        var vio = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            var v = e.target;
            if (e.isIntersecting && e.intersectionRatio >= 0.5){ var pr = v.play(); if (pr && pr.catch) pr.catch(function(){}); }
            else { v.pause(); setMuted(v, true); }
          });
        }, { threshold: [0, 0.5, 1] });
        videos.forEach(function(v){ if (v) vio.observe(v); });
      }
    });

    /* ---- review marquee ---- */
    scope.querySelectorAll('[data-revtrack]:not([data-osb-rev])').forEach(function(track){
      track.setAttribute('data-osb-rev','');
      var originals = Array.prototype.slice.call(track.children);
      if (reduce || originals.length < 2) return;
      originals.forEach(function(c){
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      var firstClone = track.children[originals.length];
      var paused = false, resumeT = null;
      function pause(){ paused = true; if (resumeT) clearTimeout(resumeT); resumeT = setTimeout(function(){ paused = false; }, 2500); }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function(ev){ track.addEventListener(ev, pause, { passive: true }); });
      track.addEventListener('mouseenter', function(){ paused = true; });
      track.addEventListener('mouseleave', function(){ paused = false; });
      var speed = 0.4;
      function tick(){
        if (!paused){
          track.scrollLeft += speed;
          var wrap = firstClone.offsetLeft;
          if (wrap > 0 && track.scrollLeft >= wrap){ track.scrollLeft -= wrap; }
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });

    /* ---- tab hint dismiss ---- */
    scope.querySelectorAll('[data-hint]:not([data-osb-hint])').forEach(function(group){
      group.setAttribute('data-osb-hint','');
      group.querySelectorAll('[data-tab]').forEach(function(btn){
        btn.addEventListener('click', function(){ group.setAttribute('data-hinted',''); });
      });
    });
  }

  if (window.__osPdpInit) return;
  window.__osPdpInit = true;
  function boot(){ init(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function(e){ init((e && e.target) || document); });
})();
